package ui

import models.ChichenItza
import models.ChristRedeemer
import models.Colosseum
import models.GreatWall
import models.MachuPicchu
import models.Petra
import models.PyramidsGiza
import models.TajMahal
import models.Wonder


object ImagePaths {
    const val root = "files/images"
    val collectibles = "$root/collectibles"
}


// For wonder specific assets, add an extension property to Wonder for easy lookup
val assetPath: String
    get() = "${ImagePaths.root}/taj_mahal"

fun getAssetPath(name: String): String {
    return "$assetPath/$name"
}

val wonderButtonPath: String get() = getAssetPath("wonder-button.png")

val mainImageName: String
    get() = "taj-mahal.webp"

val homeBtnImage: String
    get() = getAssetPath("wonder-button.webp")

val photo0: String
    get() = getAssetPath("photo-0.jpg")

val photo1: String
    get() = getAssetPath("photo-1.jpg")

val photo2: String
    get() = getAssetPath("photo-2.jpg")

val photo3: String
    get() = getAssetPath("photo-3.jpg")

val photo4: String
    get() = getAssetPath("photo-4.jpg")

val photo5: String
    get() = getAssetPath("photo-5.jpg")

val flattenedImage: String
    get() = getAssetPath("flattened.png")


val celestialBodyImageName
    get() = "sun.png"
